import { render } from "./ConfirmOwnershipTransferModal.vue?vue&type=template&id=3a5af18e"
import script from "./ConfirmOwnershipTransferModal.vue?vue&type=script&lang=js"
export * from "./ConfirmOwnershipTransferModal.vue?vue&type=script&lang=js"

import "./ConfirmOwnershipTransferModal.vue?vue&type=style&index=0&id=3a5af18e&lang=scss"
/* custom blocks */
import block0 from "./ConfirmOwnershipTransferModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__